import { autocompleteClasses } from "@mui/material"
import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles<{ hasSearch?: boolean }>()(
  ({ spacing }, { hasSearch = false }) => ({
    globalSearchAutocompletePaper: {
      [`& .${autocompleteClasses.noOptions}`]: {
        padding: spacing(1, 0)
      }
    },
    popper: {
      [`& .${autocompleteClasses.noOptions}`]: {
        ...(!hasSearch && {
          display: "none"
        })
      }
    },
    inputAdornment: {
      height: "auto"
    }
  })
)
